const termsOfUse = {
  title: 'Terms of Use',
  intro: 'These terms apply to your access to and use of the ProfitYo Global website.',
  sections: [
    {
      id: 'acceptance',
      title: 'Acceptance of These Terms',
      paragraphs: [
        'By accessing or using this website, you agree to these terms. If you do not agree, please do not use the website.',
      ],
    },
    {
      id: 'website-content',
      title: 'Website Content',
      paragraphs: [
        'Website content is provided for general informational purposes and may be updated or removed at any time.',
        'You may not reproduce or distribute website content without permission, except where permitted by applicable law.',
      ],
    },
    {
      id: 'acceptable-use',
      title: 'Acceptable Use',
      paragraphs: [
        'You agree not to misuse the website, interfere with its operation, or attempt to access it through unauthorized means.',
      ],
    },
    {
      id: 'liability',
      title: 'Disclaimer and Liability',
      paragraphs: [
        'To the extent permitted by law, the website is provided without warranties, and ProfitYo Global is not liable for losses arising from its use.',
      ],
    },
    {
      id: 'contact',
      title: 'Contact',
      paragraphs: [
        'Questions about these terms may be sent to the contact email address provided on this website.',
      ],
    },
  ],
};

export default termsOfUse;